/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactNode } from "react";
import Sidebar from "../components/Comman/Sidebar";
import Header from "../components/Comman/Header";
import { Link } from "react-router-dom";

const DefaultLayout: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <div className="flex">
      <div className="main bg-[#000]">
        {/* Sidebar */}
        <Sidebar
          sidebarOpen={false}
          setSidebarOpen={(arg: boolean) => {
            console.error("Function not implemented:", arg);
          }}
        />

        {/* Content Area */}
        <div className="mainBody  flex flex-col">
          <main className="bg-gray flex-1">
            <Header />
            <section className="mx-auto max-w-screen-3xl mt-[132px] px-[20px]">
              {children}
            </section>
          </main>

          {/* Footer */}
          <div className="footerbusinessLanding bg-[#10151A] p-[20px] mt-[20px]">
            <div className="text-center">
              <div className="footerbusinesstext flex justify-between">
                <div className="flex space-x-4">
                  <Link
                    to="/terms-and-conditions"
                    className="border-r border-gray-400 pr-4 text-white text-[12px] last:border-r-0"
                  >
                  Terms & Conditions
                  </Link>
                  {/* <Link
                    to="/privacy"
                    className="border-r border-gray-400 pr-4 text-white text-[12px] last:border-r-0"
                  >
                    Privacy Policy
                  </Link> */}
                  <a
                    href="#"
                    className="border-r border-gray-400 pr-4 text-white text-[12px] last:border-r-0"
                  >
                    Settings
                  </a>
                </div>

                <div className="flex space-x-4">
                  <a
                    href="#"
                    className="border-r border-gray-400 pr-4 text-white text-[12px] last:border-r-0"
                  >
                    Copyright 2025.{" "}
                  </a>
                  <a
                    href="#"
                    className="border-r border-gray-400 pr-4 text-white text-[12px] last:border-r-0"
                  >
                    All Rights Reserved.
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefaultLayout;
